import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import tr from '../locales/tr.json';
import de from '../locales/de.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';

const STORAGE_KEY = 'tps-app-language';
const SUPPORTED_LANGUAGES = ['en', 'tr', 'de', 'es', 'fr'] as const;

const saved =
  typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
const initialLng =
  saved && (SUPPORTED_LANGUAGES as readonly string[]).includes(saved) ? saved : 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    tr: { translation: tr },
    de: { translation: de },
    es: { translation: es },
    fr: { translation: fr },
  },
  lng: initialLng,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, lng);
  }
});

/** Escape hatch for `i18n.t` outside React (avoids strict default `TFunction` typing). */
export const translate = i18n.t.bind(i18n) as (
  key: string,
  options?: Record<string, string | number>
) => string;

export default i18n;
